import Container from './editable/Container.js';
import Input from './editable/Input.js';
import notification from 'notification-js';
import Config from 'config';

let licences = [];

const LICENSE_APPLICATION = "application";
const LICENSE_ADDON = "addon";

export const mapping = ({data, path}) => {
  return {
    prices: data.prices
  }
}

export const transform = ({modal, path, updateState}) => {
  return {
    prices: {
      dom: '.editor-fields-buynow',
      callback: function() {
        let editorFields = modal.el.getElementsByClassName('editor-fields')[0];
        editorFields.__dirty = false;
        let priceElements = modal.el.getElementsByClassName('slide-edit');
        for (var index = 0; index < this.prices.length; index++) {
          let price = this.prices[index];
          let parentDeleteButton = priceElements[index].getElementsByClassName('delete');

          parentDeleteButton = parentDeleteButton[parentDeleteButton.length - 1];

          var selectLicence = priceElements[index].getElementsByClassName('licence-choose')[0];

          selectLicence.value = price.licenceId;

          selectLicence.onchange = (event) => {
            editorFields.__dirty = true;
            price.licenceId = event.target.value;
            price.amount =  event.target.selectedOptions[0].dataset.amount;
            price.amountTerm =  event.target.selectedOptions[0].dataset.amountTerm;
            updateState();
          }

          let priceElement = new Container({element: priceElements[index],
                                            editable: true,
                                            data: this.prices,
                                            index,
                                            updateState,
                                            deleteButton: parentDeleteButton,
                                            onDelete: deletePrice});

          const updateTextValue = (event) => {
            editorFields.__dirty = true;
            price.name = priceElement.getField('name').value;
            updateState();
          };

          priceElement.getField('name').onkeyup = updateTextValue;
        }

      },
      transform: function(price) {
        var selectLicenceContainer = document.createElement('div');
        var selectLicence = document.createElement('select');

        selectLicence.className = "licence-choose";

        var option = document.createElement("option");
        option.value = 0;
        option.text = "Choose Licence";

        selectLicence.appendChild(option);

        let productLicenses = [];
        // for products we show only applications licenses
        licences.forEach(function (license) {
          if (license.type == LICENSE_ADDON) {
            productLicenses.push(license);
          }
        });

        if (productLicenses.length > 0) {
          for (var i =0; i < productLicenses.length; i++) {
            var option = document.createElement("option");
            option.value = productLicenses[i].ID;
            option.text = productLicenses[i].name;
            option.dataset.amount = productLicenses[i].payMonthly ? productLicenses[i].monthlyAmount : productLicenses[i].yearlyAmount;
            option.dataset.amountTerm = productLicenses[i].payMonthly ? 'month' : 'year';

            selectLicence.appendChild(option);
          }
        }

        selectLicenceContainer.appendChild(selectLicence);

        return `
          <div class="buy-now-edit">
            <div class="price field-item-container">
              <div class="slide slide-edit price-edit">
                <input type="text" name="name" class="name" value="` + price.name + `">

                ${selectLicenceContainer.innerHTML}
                <br/>

                <a href="#" class="delete" style="display:none;">Delete</a>
              </div>
            </div>
          </div>`;
      }
    }
  }
}

const updateData = ({modal, editor, data, updateState}) => {
  data.prices.forEach((price, index) => {
    if (editor.prices[index]) {
      editor.prices[index].name = price.name;
      editor.prices[index].amount = price.amount;
      editor.prices[index].amountTerm = price.amountTerm ? price.amountTerm : 'month';
      editor.prices[index].licenceId = price.licenceId;
    } else {
      editor.prices.push(price);
    }
  });
}

export const loadForm = ({modal, editor, data, path, updateState}) => {
  //editor.prices = [];
  var xobj = new XMLHttpRequest();
  xobj.overrideMimeType("application/json");
  xobj.open("POST", Config.BACKEND_URL + '/retrieveLicences?t=' + Math.floor(Date.now() / 1000));
  xobj.onreadystatechange = function () {
    if (xobj.readyState == 4) {
      if (xobj.status == "200") {
        licences = JSON.parse(xobj.response).licences;
        // Required use of an anonymous callback as .open will NOT return a value
        // but simply returns undefined in asynchronous mode
        updateData({modal, editor, data, updateState});
      }
    }
  };
  xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xobj.setRequestHeader("AUTH-TOKEN", Config.authToken);
  xobj.send();

  let addPriceButton = modal.el.getElementsByClassName("addSlide")[0];

  addPriceButton.onclick = (event) => {
    addPrice(event, modal, editor.prices, updateState);
  }
};

const addPrice = (event, modal, prices, updateState) => {
  event.preventDefault();
  prices.push({name: 'Enter title here', selectedOption: 0, options: [{users: '0', amount: '0', frequency: 'per month'}]});
  let editorFields = modal.el.getElementsByClassName('editor-fields')[0];

  editorFields.scrollLeft = editorFields.offsetWidth;
  updateState();
}

const deletePrice = (event, prices, index, updateState) => {
  event.preventDefault();

  if (prices.length > 1) {
    prices.splice(index, 1);
    updateState();
  } else {
    notification.notify( 'error', 'Unable to delete last price group', {
      notification: {position: [ 'right', 'top' ]}
    });
  }
}

export const getData = (currentState, editor) => {
  currentState.prices = [];

  editor.prices.forEach((price, index) => {
    let newPrice = {};
    newPrice.name = price.name;
    newPrice.licenceId = price.licenceId;
    newPrice.amount = price.amount;
    newPrice.amountTerm = price.amountTerm;
    currentState.prices.push(newPrice);
  });

  return currentState;
}

export default function() {
  let template = `
    <div class="form">
      <div class="editor-fields editor-fields-buynow">
      </div>
      <div class="field-item-container add-more">
        <div class="slide">
          <a href="#" class="addSlide">+</a>
        </div>
      </div>
    </div>
  `

  return `<div>
    ${template}
  </div>`;
};



// WEBPACK FOOTER //
// ./src/editors/BuyAddons.js